import { render, staticRenderFns } from "./renewalOrderDetail.vue?vue&type=template&id=4c155035&scoped=true"
import script from "./renewalOrderDetail.vue?vue&type=script&lang=js"
export * from "./renewalOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./renewalOrderDetail.vue?vue&type=style&index=0&id=4c155035&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c155035",
  null
  
)

export default component.exports